




























































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import L from 'leaflet';
import * as esri from 'esri-leaflet';
import { MinMax } from '@/models/MinMax';
import { Filter } from '@/models/Filter';

@Component
export default class FilterDialog extends Vue {

    public showDialog: boolean = false;
    public widthThresholdValue: number = 768;
    public heightThresholdValue: number = 415;

    public spatialFilterApplied: boolean = false;
    public spatialFilterLoading: boolean = false;
    public spatialFilterLayer: L.GeoJSON | null = null;

    public isActive: boolean = true; // "1"
    public isPending: boolean = true; // "3"
    public isSold: boolean = false; // "2"

    public isWaterfront: boolean = false;
    public isGarage: boolean = false;

    public filterClass: any = [];
    public filterType: any = [];
    public filterStyle: any = [];
    public filterHeat: any = [];

    public priceRange = {
        // steps
        min: 0,
        max: 49,
    };

    public bedsRange = {
        min: 0,
        max: 10,
    };

    public bathsRange = {
        min: 0,
        max: 10,
    };

    public mlaRange = {
        min: 0,
        max: 7500,
    };

    public tlaRange = {
        min: 0,
        max: 7500,
    };

    public lotRange = {
        // steps
        min: 0,
        max: 15,
    };

    public ageRange = {
        min: 0,
        max: 100,
    };

    public schoolCatchment = {
        label: '- no school selected -',
        value: '0',
    };

    public spatialFilterStyle = {
        color: '#DC1C2E',
        fillColor: '#DC1C2E',
        weight: 4,
        opacity: 1,
        fillOpacity: 0.15,
    };

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'showFilterDialog') {
            this.onShowDialog();
        }
        if (action.type === 'clearActiveFilter') {
            this.onClearSpatialFilter();
        }
        if (action.type === 'setSpatialFilter') {
            if (action.payload) {
                this.onShowSpatialFilter(action.payload);
            }
        }
    });

    get config() {
        return this.$store.state.config;
    }

    get isMobile(): boolean {
        return (this.$q.screen.width <= this.widthThresholdValue) || (this.$q.screen.height <= this.heightThresholdValue);
    }

    get map() {
        return this.$store.state.map;
    }

    get classOptions() {
        return this.$store.state.config.FilterOptions.ClassOptions;
    }

    get typeOptions() {
        // UI says these are type options even though they are listed under style
        return this.$store.state.config.FilterOptions.StyleOptions;
    }

    get styleOptions() {
        // UI says these are style options even though they are listed under type
        return this.$store.state.config.FilterOptions.ResidentialTypeOptions.concat(this.$store.state.config.FilterOptions.CommercialTypeOptions);
    }

    get heatOptions() {
        return this.$store.state.config.FilterOptions.HeatTypeOptions;
    }

    get schoolCatchmentOptions() {
        return this.$store.state.config.FilterOptions.SchoolOptions;
    }

    get priceLabelMin() {
        const priceOption = this.config.FilterOptions.PriceMinOptions.find((options: any) => options.step === this.priceRange.min);
        return priceOption.label;
    }

    get priceLabelMax() {
        const priceOption = this.config.FilterOptions.PriceMaxOptions.find((options: any) => options.step === this.priceRange.max);
        return priceOption.label;
    }

    get lotLabelMin() {
        const lotOption = this.config.FilterOptions.LotSizeMinOptions.find((options: any) => options.step === this.lotRange.min);
        return lotOption.label;
    }

    get lotLabelMax() {
        const lotOption = this.config.FilterOptions.LotSizeMaxOptions.find((options: any) => options.step === this.lotRange.max);
        return lotOption.label;
    }

    get activeFilter(): Filter | null {
        return this.$store.state.filters.activeFilter;
    }

    @Watch('activeFilter', { immediate: false, deep: true })
    public activeFilterChanged(newFilter: Filter, oldFilter: Filter) {
        // a filter may get restored, controls needs to sync up...
        console.log('FilterDialog: activeFilter Changed');
        if (!this.showDialog) {
            console.log('FilterDialog: updating filter dialog');
            if (JSON.stringify(newFilter.Status) !== JSON.stringify(oldFilter.Status)) {
                this.isActive = newFilter.Status.value.indexOf('1') !== -1 ? true : false;
                this.isPending = newFilter.Status.value.indexOf('3') !== -1 ? true : false;
                this.isSold = newFilter.Status.value.indexOf('2') !== -1 ? true : false;
            }
            if (JSON.stringify(newFilter.Waterfront) !== JSON.stringify(oldFilter.Waterfront)) {
                this.isWaterfront = newFilter.Waterfront.value === 1 ? true : false;
            }
            if (JSON.stringify(newFilter.Garage) !== JSON.stringify(oldFilter.Garage)) {
                this.isGarage = newFilter.Garage.value === 1 ? true : false;
            }

            if (JSON.stringify(newFilter.Class) !== JSON.stringify(oldFilter.Class)) {
                this.filterClass = newFilter.Class.value;
            }
            if (JSON.stringify(newFilter.Type) !== JSON.stringify(oldFilter.Type)) {
                this.filterType = newFilter.Style.value;
            }
            if (JSON.stringify(newFilter.Style) !== JSON.stringify(oldFilter.Style)) {
                this.filterStyle = newFilter.Type.value;
            }
            if (JSON.stringify(newFilter.HeatType) !== JSON.stringify(oldFilter.HeatType)) {
                this.filterHeat = newFilter.HeatType.value ? newFilter.HeatType.value : [];
            }
            if (JSON.stringify(newFilter.Beds) !== JSON.stringify(oldFilter.Beds)) {
                this.bedsRange = {
                    min: newFilter.Beds.Min,
                    max: newFilter.Beds.Max === this.config.FilterOptions.BedNoMaxVal ? 10 : newFilter.Beds.Max,
                };
            }
            if (JSON.stringify(newFilter.Baths) !== JSON.stringify(oldFilter.Baths)) {
                this.bathsRange = {
                    min: newFilter.Baths.Min,
                    max: newFilter.Baths.Max === this.config.FilterOptions.BathNoMaxVal ? 10 : newFilter.Baths.Max,
                };
            }
            if (JSON.stringify(newFilter.Mla) !== JSON.stringify(oldFilter.Mla)) {
                this.mlaRange = {
                    min: newFilter.Mla.Min,
                    max: newFilter.Mla.Max === this.config.FilterOptions.MlaNoMaxVal ? 7500 : newFilter.Mla.Max,
                };
            }
            if (JSON.stringify(newFilter.Tla) !== JSON.stringify(oldFilter.Tla)) {
                this.tlaRange = {
                    min: newFilter.Tla.Min,
                    max: newFilter.Tla.Max === this.config.FilterOptions.TlaNoMaxVal ? 7500 : newFilter.Tla.Max,
                };
            }
            if (JSON.stringify(newFilter.Price) !== JSON.stringify(oldFilter.Price)) {
                const priceMin = this.config.FilterOptions.PriceMinOptions.find((options: any) => options.value === newFilter.Price.Min);
                const priceMax = this.config.FilterOptions.PriceMaxOptions.find((options: any) => options.value === newFilter.Price.Max);
                this.priceRange = {
                    min: priceMin.step,
                    max: priceMax.step,
                };
            }
            if (JSON.stringify(newFilter.LotSize) !== JSON.stringify(oldFilter.LotSize)) {
                const lotMin = this.config.FilterOptions.LotSizeMinOptions.find((options: any) => options.value === newFilter.LotSize.Min);
                const lotMax = this.config.FilterOptions.LotSizeMaxOptions.find((options: any) => options.value === newFilter.LotSize.Max);
                this.lotRange = {
                    min: lotMin.step,
                    max: lotMax.step,
                };
            }
            if (JSON.stringify(newFilter.Age) !== JSON.stringify(oldFilter.Age)) {
                this.ageRange = {
                    min: newFilter.Age.Min,
                    max: newFilter.Age.Max === this.config.FilterOptions.AgeNoMaxVal ? 100 : newFilter.Age.Max,
                };
            }
            if (JSON.stringify(newFilter.SchoolCatchmentId) !== JSON.stringify(oldFilter.SchoolCatchmentId)) {
                let selectedOption = this.schoolCatchmentOptions.find((options: any) => options.value === newFilter.SchoolCatchmentId.value);
                if (!selectedOption) {
                    selectedOption =  { label: '- no school selected -', value: '0'};
                    this.schoolCatchment = selectedOption;
                } else {
                    this.schoolCatchment = selectedOption;
                    this.spatialFilterApplied = true;
                    if (this.spatialFilterLayer) {
                        this.spatialFilterLayer.removeFrom(this.map);
                    }
                    this.onSchoolFilter();
                }
            }
        }
    }

    public onFilterDialogHide() {
        console.log('FilterDialog: onFilterDialogHide()');
    }

    public onShowDialog() {
        this.showDialog = true;
    }

    public onClearSpatialFilter() {
        console.log('FilterDialog: onClearSpatialFilter()');
        if (this.spatialFilterApplied) {
            if (this.spatialFilterLayer) {
                this.spatialFilterLayer.removeFrom(this.map);
                // this.$store.dispatch('setSchoolCatchmentId', null);
                this.$store.dispatch('setSpatialFilter', null);
            }
            this.spatialFilterApplied = false;
        }
    }

    public onShowSpatialFilter(spatialFilter: string) {
        console.log('FilterDialog: onShowSpatialFilter');
        if (this.spatialFilterLayer) {
            this.spatialFilterLayer.removeFrom(this.map);
        }

        this.spatialFilterLayer = L.geoJSON(JSON.parse(spatialFilter),
            {
                style: this.spatialFilterStyle,
                pane: 'vector',
            }).addTo(this.map);
        this.map.fitBounds(this.spatialFilterLayer.getBounds());

        this.spatialFilterApplied = true;
    }

    public onApplyFilter() {
        console.log('FilterDialog: onApplyFilter()');
        if (this.spatialFilterApplied) {
            if (this.spatialFilterLayer) {
                console.log('set SF draw polygon');
                this.$store.dispatch('setSpatialFilter', this.spatialFilterLayer);
                this.applyAttributeFilter();
                this.showDialog = false;
            }
        } else if (this.schoolCatchment.value !== '0') {
            console.log('set SF school catchment');
            this.spatialFilterLoading = true;
            this.onSchoolFilter(); // if there is an attribute filter it gets applied after school spatial is set
        } else {
            this.applyAttributeFilter();
            this.showDialog = false;
        }
    }

    public applyAttributeFilter() {
        const priceMin = this.config.FilterOptions.PriceMinOptions.find((options: any) => options.step === this.priceRange.min);
        const priceMax = this.config.FilterOptions.PriceMaxOptions.find((options: any) => options.step === this.priceRange.max);
        const lotMin = this.config.FilterOptions.LotSizeMinOptions.find((options: any) => options.step === this.lotRange.min);
        const lotMax = this.config.FilterOptions.LotSizeMaxOptions.find((options: any) => options.step === this.lotRange.max);

        const status: string[] = [];
        if (this.isActive) {
            status.push('1');
        }
        if (this.isPending) {
            status.push('3');
        }
        if (this.isSold) {
            status.push('2');
        }

        const newFilter = new Filter({
            price: { min: priceMin.value, max: priceMax.value },
            beds: { min: this.bedsRange.min, max: this.bedsRange.max === 10 ? this.config.FilterOptions.BedNoMaxVal : this.bedsRange.max },
            baths: { min: this.bathsRange.min, max: this.bathsRange.max === 10 ? this.config.FilterOptions.BathNoMaxVal : this.bathsRange.max },
            mla: { min: this.mlaRange.min, max: this.mlaRange.max === 7500 ? this.config.FilterOptions.MlaNoMaxVal : this.mlaRange.max },
            tla: { min: this.tlaRange.min, max: this.tlaRange.max === 7500 ? this.config.FilterOptions.TlaNoMaxVal : this.tlaRange.max },
            lotSize: { min: lotMin.value, max: lotMax.value },
            age: { min: this.ageRange.min, max: this.ageRange.max === 100 ? this.config.FilterOptions.AgeNoMaxVal : this.ageRange.max },
            type: { value: this.filterStyle },
            style: { value: this.filterType },
            class: { value: this.filterClass },
            status: { value: status },
            heatType: { value: this.filterHeat },
            waterfront: { value: this.isWaterfront ? 1 : null },
            garage: { value: this.isGarage ? 1 : null },
            schoolCatchmentId: { value: this.schoolCatchment.value === '0' ? null : this.schoolCatchment.value },
        });
        console.log(newFilter);
        this.$store.dispatch('setActiveFilter', newFilter);
    }

    public onSchoolFilter() {
        this.spatialFilterLoading = true;

        const schoolQuery = esri.query({
            url: this.config.SchoolCatchmentLayer.url,
            proxy: this.config.proxy.url,
        });

        schoolQuery.where('OBJECTID=' + this.schoolCatchment.value);

        console.log('FilterDialog: schoolQuery.run');
        schoolQuery.run((error, featureCollection) => {
            if (!error && featureCollection.features.length > 0) {
                this.$store.dispatch('setSpatialFilter', JSON.stringify(L.geoJSON(featureCollection.features[0]).toGeoJSON()));
                this.$store.dispatch('setSchoolCatchmentId', this.schoolCatchment.value);

                this.spatialFilterLoading = false;

                this.applyAttributeFilter();
                this.showDialog = false;

            } else {
                // Logger.writeError("failed to get School:" + error);
                // ErrorMgr.logError("failed to get School:" + error);
                console.error(error);
                this.spatialFilterLoading = false;
                this.applyAttributeFilter();
                this.showDialog = false;
            }
        });

    }

    public onClearAll() {
        this.$store.dispatch('clearActiveFilter');
        this.showDialog = false;
    }

}

